"use strict";

var _objectSpread = require("/var/www/ivy-temp/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPOTLIGHT_SORT_DESCRIPTIONS = exports.SPOTLIGHT_SORT_LABELS = exports.DEFAULT_SPOTLIGHT_SORT_ORDER = exports.SPOTLIGHT_RANKED_ACTIVITY_KEYS = exports.VENUE_AGGREGATE_SUB_ORDER = exports.VENUE_AGGREGATE_ACTIVITY_KEY = exports.DEFAULT_MAP_FILTER_LABELS = exports.VENUE_ACTIVITY_COLORS = exports.MAP_FILTER_KEY_ORDER = exports.MAX_SPOTLIGHT_VENUE_COUNT = exports.MIN_SPOTLIGHT_VENUE_COUNT = exports.MAX_SPOTLIGHT_VENUE_CANDIDATES = exports.DEFAULT_SPOTLIGHT_VENUE_COUNT = void 0;
exports.defaultPositionForMapFilterKey = defaultPositionForMapFilterKey;
exports.sortMapFiltersByPosition = sortMapFiltersByPosition;
exports.getSpotlightSortLabel = getSpotlightSortLabel;
exports.getSpotlightEventsOrVisitPlansActivityValue = getSpotlightEventsOrVisitPlansActivityValue;
exports.buildMapFilterPositionIndex = buildMapFilterPositionIndex;
exports.sortVenueAggregatesByMapFilterOrder = sortVenueAggregatesByMapFilterOrder;
exports.buildSpotlightSortCriteria = buildSpotlightSortCriteria;
exports.compareSpotlightActivityRank = compareSpotlightActivityRank;
exports.isMapFilterVisibleInUi = isMapFilterVisibleInUi;
exports.visibleMapFilters = visibleMapFilters;
exports.buildDefaultMapFilterConfig = buildDefaultMapFilterConfig;
exports.normalizeMapFilterConfig = normalizeMapFilterConfig;
exports.validateMapFilterConfigForSave = validateMapFilterConfigForSave;
exports.parseSpotlightVenueCount = parseSpotlightVenueCount;
exports.validateSpotlightVenueCount = validateSpotlightVenueCount;
exports.parseSpotlightSortOrder = parseSpotlightSortOrder;
exports.validateSpotlightSortOrderForSave = validateSpotlightSortOrderForSave;
exports.buildDefaultMapFiltersSettings = buildDefaultMapFiltersSettings;
exports.normalizeMapFiltersSettings = normalizeMapFiltersSettings;
exports.parseMapFiltersAdminSave = parseMapFiltersAdminSave;
const enums_1 = require("../enums");
const spotlight_eligibility_config_1 = require("./spotlight-eligibility-config");
const spotlight_current_venue_config_1 = require("./spotlight-current-venue-config");
const spotlight_trending_config_1 = require("./spotlight-trending-config");
const spotlight_badge_priority_1 = require("./spotlight-badge-priority");
const venue_aggregate_windows_config_1 = require("./venue-aggregate-windows-config");
/** Default number of ranked venues returned from spotlight API. */
exports.DEFAULT_SPOTLIGHT_VENUE_COUNT = 8;
/** Max venues the spotlight SQL candidate query loads before ranking. */
exports.MAX_SPOTLIGHT_VENUE_CANDIDATES = 200;
exports.MIN_SPOTLIGHT_VENUE_COUNT = 1;
exports.MAX_SPOTLIGHT_VENUE_COUNT = exports.MAX_SPOTLIGHT_VENUE_CANDIDATES;
/** Default key order when position is missing (legacy configs). */
exports.MAP_FILTER_KEY_ORDER = [enums_1.VenueActivityType.CheckedIns, enums_1.VenueActivityType.RecentCheckins, enums_1.VenueActivityType.Events, enums_1.VenueActivityType.VisitPlans, enums_1.VenueActivityType.Breadcrumbs, enums_1.VenueActivityType.Views, enums_1.VenueActivityType.Stickers];
/** Colors aligned with venue activity stats / aggregates in ExperienceService. */
exports.VENUE_ACTIVITY_COLORS = {
  [enums_1.VenueActivityType.CheckedIns]: '#aa0000',
  [enums_1.VenueActivityType.RecentCheckins]: '#cc4444',
  [enums_1.VenueActivityType.Events]: '#2270dd',
  [enums_1.VenueActivityType.VisitPlans]: '#2270dd',
  [enums_1.VenueActivityType.Breadcrumbs]: '#ffb300',
  [enums_1.VenueActivityType.Views]: '#2270dd',
  [enums_1.VenueActivityType.Stickers]: '#9747ff'
};
exports.DEFAULT_MAP_FILTER_LABELS = {
  [enums_1.VenueActivityType.CheckedIns]: 'Check-ins',
  [enums_1.VenueActivityType.RecentCheckins]: 'Recent check-ins',
  [enums_1.VenueActivityType.Events]: 'Events',
  [enums_1.VenueActivityType.VisitPlans]: 'Visit plans',
  [enums_1.VenueActivityType.Breadcrumbs]: 'Breadcrumbs',
  [enums_1.VenueActivityType.Views]: 'Views',
  [enums_1.VenueActivityType.Stickers]: 'Stickers'
};
const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;
function defaultPositionForMapFilterKey(key) {
  const index = exports.MAP_FILTER_KEY_ORDER.indexOf(key);
  return index >= 0 ? index : 0;
}
function sortMapFiltersByPosition(items) {
  return [...items].sort((a, b) => a.position - b.position);
}
/** Maps venue peek/detail aggregate rows to map-filter activity keys for ordering. */
exports.VENUE_AGGREGATE_ACTIVITY_KEY = {
  [enums_1.VenueAggregateType.CheckedInUsers]: enums_1.VenueActivityType.CheckedIns,
  [enums_1.VenueAggregateType.MatchingUsers]: enums_1.VenueActivityType.CheckedIns,
  [enums_1.VenueAggregateType.EventRsvps]: enums_1.VenueActivityType.Events,
  [enums_1.VenueAggregateType.VisitPlans]: enums_1.VenueActivityType.VisitPlans,
  [enums_1.VenueAggregateType.RecentViews]: enums_1.VenueActivityType.Views,
  [enums_1.VenueAggregateType.Breadcrumbs]: enums_1.VenueActivityType.Breadcrumbs,
  [enums_1.VenueAggregateType.Stickers]: enums_1.VenueActivityType.Stickers
};
/** Tie-break when multiple aggregates share the same map-filter activity key. */
exports.VENUE_AGGREGATE_SUB_ORDER = {
  [enums_1.VenueAggregateType.CheckedInUsers]: 0,
  [enums_1.VenueAggregateType.MatchingUsers]: 1,
  [enums_1.VenueAggregateType.EventRsvps]: 0,
  [enums_1.VenueAggregateType.VisitPlans]: 0,
  [enums_1.VenueAggregateType.RecentViews]: 0,
  [enums_1.VenueAggregateType.Breadcrumbs]: 0,
  [enums_1.VenueAggregateType.Stickers]: 0
};
/** Activity keys that participate in spotlight venue ranking (excluding tie-breakers). */
exports.SPOTLIGHT_RANKED_ACTIVITY_KEYS = [enums_1.VenueActivityType.CheckedIns, enums_1.VenueActivityType.Events, enums_1.VenueActivityType.RecentCheckins, enums_1.VenueActivityType.Breadcrumbs];
/** Default spotlight ticker ranking (independent of map filter chip order). */
exports.DEFAULT_SPOTLIGHT_SORT_ORDER = [enums_1.VenueActivityType.CheckedIns, enums_1.VenueActivityType.Events, enums_1.VenueActivityType.RecentCheckins, enums_1.VenueActivityType.Breadcrumbs];
/** Spotlight sort labels; Events covers RSVPs and visit plans at one priority slot. */
exports.SPOTLIGHT_SORT_LABELS = {
  [enums_1.VenueActivityType.Events]: 'Events / Visit plans'
};
/** Admin-facing explanation of what each spotlight sort row compares. */
exports.SPOTLIGHT_SORT_DESCRIPTIONS = {
  [enums_1.VenueActivityType.CheckedIns]: 'Users currently checked in at the venue. Venues with any check-ins beat those without; higher counts win ties.',
  [enums_1.VenueActivityType.Events]: 'Sum of event RSVPs plus visit plans scheduled for today (server timezone). Either signal can satisfy this step.',
  [enums_1.VenueActivityType.RecentCheckins]: 'Check-ins within the map-filters recent-checkins window (configured separately under Map filters).',
  [enums_1.VenueActivityType.Breadcrumbs]: 'Active venue breadcrumbs. Venues with breadcrumbs rank above those without; more breadcrumbs win ties.'
};
function getSpotlightSortLabel(key) {
  var _exports$SPOTLIGHT_SO;
  return (_exports$SPOTLIGHT_SO = exports.SPOTLIGHT_SORT_LABELS[key]) !== null && _exports$SPOTLIGHT_SO !== void 0 ? _exports$SPOTLIGHT_SO : exports.DEFAULT_MAP_FILTER_LABELS[key];
}
/** Combined activity for spotlight Events sort slot (RSVPs or visit plans). */
function getSpotlightEventsOrVisitPlansActivityValue(eventRsvpCount, visitPlanCount) {
  return eventRsvpCount + visitPlanCount;
}
function buildMapFilterPositionIndex(items) {
  const index = new Map();
  sortMapFiltersByPosition(items).forEach((item, position) => {
    index.set(item.key, position);
  });
  return index;
}
function sortVenueAggregatesByMapFilterOrder(aggregates, mapFilters) {
  const positionByActivity = buildMapFilterPositionIndex(mapFilters);
  return [...aggregates].sort((a, b) => {
    var _positionByActivity$g, _positionByActivity$g2;
    const activityA = exports.VENUE_AGGREGATE_ACTIVITY_KEY[a.type];
    const activityB = exports.VENUE_AGGREGATE_ACTIVITY_KEY[b.type];
    const positionA = (_positionByActivity$g = positionByActivity.get(activityA)) !== null && _positionByActivity$g !== void 0 ? _positionByActivity$g : Number.MAX_SAFE_INTEGER;
    const positionB = (_positionByActivity$g2 = positionByActivity.get(activityB)) !== null && _positionByActivity$g2 !== void 0 ? _positionByActivity$g2 : Number.MAX_SAFE_INTEGER;
    if (positionA !== positionB) {
      return positionA - positionB;
    }
    return exports.VENUE_AGGREGATE_SUB_ORDER[a.type] - exports.VENUE_AGGREGATE_SUB_ORDER[b.type];
  });
}
/** Spotlight sort: optional current venue first, then ranked activities in admin order, then views & distance. */
function buildSpotlightSortCriteria(spotlightSortOrder) {
  let pinCurrentVenueFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const ranked = new Set(exports.SPOTLIGHT_RANKED_ACTIVITY_KEYS);
  const criteria = pinCurrentVenueFirst ? ['currentVenue'] : [];
  for (const key of spotlightSortOrder) {
    if (ranked.has(key) && !criteria.includes(key)) {
      criteria.push(key);
    }
  }
  for (const key of exports.SPOTLIGHT_RANKED_ACTIVITY_KEYS) {
    if (!criteria.includes(key)) {
      criteria.push(key);
    }
  }
  criteria.push('interestedUsers', 'distance');
  return criteria;
}
/** Descending presence/count comparison used for spotlight activity ranking. */
function compareSpotlightActivityRank(aValue, bValue) {
  const aHas = aValue > 0;
  const bHas = bValue > 0;
  if (aHas !== bHas) {
    return aHas ? -1 : 1;
  }
  if (aHas && bHas && aValue !== bValue) {
    return bValue - aValue;
  }
  return 0;
}
/** Whether the filter chip should appear in the map filter bar. */
function isMapFilterVisibleInUi(state) {
  return state !== enums_1.MapFilterState.Hidden;
}
/** Filters intended for rendering in the map UI (excludes Hidden). */
function visibleMapFilters(items) {
  return sortMapFiltersByPosition(items).filter(item => isMapFilterVisibleInUi(item.state));
}
function buildDefaultMapFilterConfig() {
  return exports.MAP_FILTER_KEY_ORDER.map((key, position) => ({
    key,
    label: exports.DEFAULT_MAP_FILTER_LABELS[key],
    position,
    color: exports.VENUE_ACTIVITY_COLORS[key],
    state: key === enums_1.VenueActivityType.CheckedIns ? enums_1.MapFilterState.Init : enums_1.MapFilterState.Default,
    payload: null
  }));
}
function isPlainObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function parsePayload(value) {
  if (value === undefined) return undefined;
  if (value === null) return null;
  return isPlainObject(value) ? value : undefined;
}
function parsePosition(value, key) {
  if (value === undefined || value === null) {
    return defaultPositionForMapFilterKey(key);
  }
  if (typeof value === 'number' && Number.isInteger(value) && value >= 0) {
    return value;
  }
  return null;
}
function parseItem(raw) {
  if (!isPlainObject(raw)) return null;
  const key = raw.key;
  if (typeof key !== 'string' || !Object.values(enums_1.VenueActivityType).includes(key)) {
    return null;
  }
  const typedKey = key;
  const label = raw.label;
  if (typeof label !== 'string' || label.trim().length === 0) {
    return null;
  }
  const position = parsePosition(raw.position, typedKey);
  if (position === null) {
    return null;
  }
  const color = raw.color;
  if (typeof color !== 'string' || !HEX_COLOR.test(color.trim())) {
    return null;
  }
  const state = raw.state;
  if (typeof state !== 'string' || !Object.values(enums_1.MapFilterState).includes(state)) {
    return null;
  }
  const payload = parsePayload(raw.payload);
  if (raw.payload !== undefined && raw.payload !== null && payload === undefined) {
    return null;
  }
  return {
    key: typedKey,
    label: label.trim(),
    position,
    color: color.trim(),
    state: state,
    payload: payload !== null && payload !== void 0 ? payload : null
  };
}
function validatePositions(items) {
  const count = items.length;
  const positions = items.map(item => item.position);
  const unique = new Set(positions);
  if (unique.size !== count) {
    return {
      message: 'Each map filter must have a unique position.'
    };
  }
  for (const position of positions) {
    if (position < 0 || position >= count) {
      return {
        message: "Positions must be integers from 0 to ".concat(count - 1, ".")
      };
    }
  }
  return null;
}
/** Assign 0..n-1 after sort so legacy configs stay valid when new keys are added. */
function ensureUniqueSequentialPositions(items) {
  const ordered = [...items].sort((a, b) => {
    const byPosition = a.position - b.position;
    if (byPosition !== 0) return byPosition;
    return exports.MAP_FILTER_KEY_ORDER.indexOf(a.key) - exports.MAP_FILTER_KEY_ORDER.indexOf(b.key);
  });
  return ordered.map((item, position) => _objectSpread(_objectSpread({}, item), {}, {
    position
  }));
}
/** Merge stored config with defaults so every activity key is always present. */
function normalizeMapFilterConfig(raw) {
  const defaults = buildDefaultMapFilterConfig();
  const byKey = new Map();
  for (const item of defaults) {
    byKey.set(item.key, _objectSpread({}, item));
  }
  if (!Array.isArray(raw)) {
    return ensureUniqueSequentialPositions(exports.MAP_FILTER_KEY_ORDER.map(key => byKey.get(key)));
  }
  for (const entry of raw) {
    const parsed = parseItem(entry);
    if (parsed) {
      byKey.set(parsed.key, parsed);
    }
  }
  return ensureUniqueSequentialPositions(exports.MAP_FILTER_KEY_ORDER.map(key => byKey.get(key)));
}
function validateMapFilterConfigForSave(value) {
  if (!Array.isArray(value)) {
    return {
      message: 'mapFilters must be an array.'
    };
  }
  const seen = new Set();
  const parsed = [];
  for (let i = 0; i < value.length; i++) {
    const item = parseItem(value[i]);
    if (!item) {
      return {
        message: "Invalid map filter at index ".concat(i, ".")
      };
    }
    if (seen.has(item.key)) {
      return {
        message: "Duplicate map filter key \"".concat(item.key, "\".")
      };
    }
    seen.add(item.key);
    parsed.push(item);
  }
  for (const key of exports.MAP_FILTER_KEY_ORDER) {
    if (!seen.has(key)) {
      return {
        message: "Missing map filter for \"".concat(key, "\".")
      };
    }
  }
  if (parsed.length !== exports.MAP_FILTER_KEY_ORDER.length) {
    return {
      message: 'mapFilters must include exactly one entry per activity type.'
    };
  }
  return validatePositions(parsed);
}
function parseSpotlightVenueCount(raw) {
  if (typeof raw === 'number' && Number.isInteger(raw)) {
    if (raw >= exports.MIN_SPOTLIGHT_VENUE_COUNT && raw <= exports.MAX_SPOTLIGHT_VENUE_COUNT) {
      return raw;
    }
  }
  return exports.DEFAULT_SPOTLIGHT_VENUE_COUNT;
}
function validateSpotlightVenueCount(value) {
  if (typeof value !== 'number' || !Number.isInteger(value)) {
    return {
      message: 'spotlightVenueCount must be an integer.'
    };
  }
  if (value < exports.MIN_SPOTLIGHT_VENUE_COUNT || value > exports.MAX_SPOTLIGHT_VENUE_COUNT) {
    return {
      message: "spotlightVenueCount must be between ".concat(exports.MIN_SPOTLIGHT_VENUE_COUNT, " and ").concat(exports.MAX_SPOTLIGHT_VENUE_COUNT, ".")
    };
  }
  return null;
}
function parseSpotlightSortOrder(raw) {
  if (!Array.isArray(raw)) {
    return [...exports.DEFAULT_SPOTLIGHT_SORT_ORDER];
  }
  const ranked = new Set(exports.SPOTLIGHT_RANKED_ACTIVITY_KEYS);
  const seen = new Set();
  const order = [];
  for (const entry of raw) {
    if (typeof entry !== 'string' || !ranked.has(entry) || seen.has(entry)) {
      continue;
    }
    const key = entry;
    seen.add(key);
    order.push(key);
  }
  for (const key of exports.DEFAULT_SPOTLIGHT_SORT_ORDER) {
    if (!seen.has(key)) {
      order.push(key);
    }
  }
  return order;
}
function validateSpotlightSortOrderForSave(value) {
  if (!Array.isArray(value)) {
    return {
      message: 'spotlightSortOrder must be an array.'
    };
  }
  if (value.length !== exports.SPOTLIGHT_RANKED_ACTIVITY_KEYS.length) {
    return {
      message: "spotlightSortOrder must include exactly ".concat(exports.SPOTLIGHT_RANKED_ACTIVITY_KEYS.length, " entries.")
    };
  }
  const seen = new Set();
  for (let i = 0; i < value.length; i++) {
    const entry = value[i];
    if (typeof entry !== 'string' || !exports.SPOTLIGHT_RANKED_ACTIVITY_KEYS.includes(entry)) {
      return {
        message: "Invalid spotlight sort key at index ".concat(i, ".")
      };
    }
    const key = entry;
    if (seen.has(key)) {
      return {
        message: "Duplicate spotlight sort key \"".concat(key, "\".")
      };
    }
    seen.add(key);
  }
  return null;
}
function buildDefaultMapFiltersSettings() {
  return {
    filters: buildDefaultMapFilterConfig(),
    spotlightVenueCount: exports.DEFAULT_SPOTLIGHT_VENUE_COUNT,
    spotlightSortOrder: [...exports.DEFAULT_SPOTLIGHT_SORT_ORDER],
    spotlightEligibility: (0, spotlight_eligibility_config_1.parseSpotlightEligibility)(undefined),
    spotlightCurrentVenue: (0, spotlight_current_venue_config_1.parseSpotlightCurrentVenue)(undefined),
    spotlightTrending: (0, spotlight_trending_config_1.parseSpotlightTrending)(undefined),
    spotlightBadgePriority: (0, spotlight_badge_priority_1.parseSpotlightBadgePriority)(undefined),
    venueAggregateWindows: (0, venue_aggregate_windows_config_1.parseVenueAggregateWindows)(undefined)
  };
}
function normalizeMapFiltersSettings(filtersRaw, spotlightVenueCountRaw, spotlightSortOrderRaw, spotlightEligibilityRaw, spotlightCurrentVenueRaw, venueAggregateWindowsRaw, spotlightTrendingRaw, spotlightBadgePriorityRaw) {
  return {
    filters: normalizeMapFilterConfig(filtersRaw),
    spotlightVenueCount: parseSpotlightVenueCount(spotlightVenueCountRaw),
    spotlightSortOrder: parseSpotlightSortOrder(spotlightSortOrderRaw),
    spotlightEligibility: (0, spotlight_eligibility_config_1.parseSpotlightEligibility)(spotlightEligibilityRaw),
    spotlightCurrentVenue: (0, spotlight_current_venue_config_1.parseSpotlightCurrentVenue)(spotlightCurrentVenueRaw),
    spotlightTrending: (0, spotlight_trending_config_1.parseSpotlightTrending)(spotlightTrendingRaw),
    spotlightBadgePriority: (0, spotlight_badge_priority_1.parseSpotlightBadgePriority)(spotlightBadgePriorityRaw),
    venueAggregateWindows: (0, venue_aggregate_windows_config_1.parseVenueAggregateWindows)(venueAggregateWindowsRaw)
  };
}
function parseMapFiltersAdminSave(value) {
  if (!isPlainObject(value) || !Array.isArray(value.filters)) {
    return null;
  }
  const spotlightVenueCount = value.spotlightVenueCount;
  if (typeof spotlightVenueCount !== 'number' || !Number.isInteger(spotlightVenueCount)) {
    return null;
  }
  if (!Array.isArray(value.spotlightSortOrder)) {
    return null;
  }
  if (!value.spotlightEligibility || typeof value.spotlightEligibility !== 'object') {
    return null;
  }
  return {
    filters: value.filters,
    spotlightVenueCount,
    spotlightSortOrder: value.spotlightSortOrder,
    spotlightEligibility: value.spotlightEligibility,
    spotlightCurrentVenue: (0, spotlight_current_venue_config_1.parseSpotlightCurrentVenue)(value.spotlightCurrentVenue),
    spotlightTrending: (0, spotlight_trending_config_1.parseSpotlightTrending)(value.spotlightTrending),
    spotlightBadgePriority: (0, spotlight_badge_priority_1.parseSpotlightBadgePriority)(value.spotlightBadgePriority),
    venueAggregateWindows: (0, venue_aggregate_windows_config_1.parseVenueAggregateWindows)(value.venueAggregateWindows)
  };
}
//# sourceMappingURL=map-filter-config.js.map